import Alert from 'client/components/ui/Alert/Alert';
import Button from 'client/components/aria/Button/Button';
import Modal from 'client/components/ui/Modal/Modal';
import { useIntl } from 'react-intl';
import styles from './WorkpackAlertModal.module.scss';

const WorkpackAlertModal = ({ showWarningDialog, setShowWarningDialog, onConfirm, workpackTitle }) => {
    const closeModal = () => {
        setShowWarningDialog(false);
    };

    const intl = useIntl();

    return (<Modal
        data-testid="WorkpackAlert.modal"
        open={showWarningDialog}>
        <Alert className={styles.alertModal} data-testid="save.bookmark.dialog.alert" variant='primary'>
            <>
                <h2 className="govuk-heading-m">{intl.formatMessage({ id: 'workpackAlerts.modal.delete.title' })}</h2>
                <p className="govuk-body">
                    {intl.formatMessage({ id: 'workpackAlerts.modal.delete.body' }, { title: workpackTitle })}
                </p>
                <div className="govuk-button-group">
                    <Button data-testid="workpackAlerts.Modal.Confirm"
                        variant="error"
                        className={styles.alertButton}
                        onPress={onConfirm}>
                        {intl.formatMessage({ id: 'workpackAlerts.modal.button.delete.text' })}
                    </Button>
                    <Button data-testid="workpackAlerts.Modal.Cancel"
                        variant="default"
                        className={styles.alertButton}
                        onPress={closeModal}>
                        {intl.formatMessage({ id: 'workpackAlerts.modal.button.cancel.text' })}
                    </Button>
                </div>
            </>
        </Alert>
    </Modal>);
};

export default WorkpackAlertModal;
